import { render, staticRenderFns } from "./PrintButton.vue?vue&type=template&id=ca65c81c&scoped=true"
import script from "./PrintButton.vue?vue&type=script&lang=js"
export * from "./PrintButton.vue?vue&type=script&lang=js"
import style0 from "./PrintButton.vue?vue&type=style&index=0&id=ca65c81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca65c81c",
  null
  
)

export default component.exports